export const DOC_TEMPLATES_EN = {
    'nav.module.doc_templates': 'Document templates',
    'nav.doc_templates.templates': 'Document templates',
    'screen.doc_templates.templates.title': 'Document templates',
    'screen.doc_templates.template.title': 'Document template',
    'screen.doc_templates.document.title': 'Document',
    'entity.doc_templates.template': 'Document template',
    'entity.doc_templates.document': 'Document',
    'entity.doc_templates.subject': 'documents',
    'doc_templates.templates.title': 'Document templates',
    'doc_templates.templates.lede': 'The text of each document your modules make, in Arabic and English; every save is a new version.',
    'doc_templates.templates.empty': 'No template yet: choose a document kind to write its text.',
    'doc_templates.template.title': 'Document template',
    'doc_templates.template.monogram': 'Tp',
    'doc_templates.document.title': 'Document',
    'doc_templates.document.monogram': 'Dc',
    'doc_templates.subject_documents.title': 'Documents',
    'doc_templates.stat.unwritten': 'Not written yet',
    'doc_templates.action.create': 'New template',
    'doc_templates.action.edit': 'Edit the text',
    'doc_templates.action.sign': 'Sign',
    'doc_templates.action.download': 'Download PDF',
    'doc_templates.action.withdraw': 'Withdraw',
    'doc_templates.alert.unwritten': 'No text yet: no document of this kind can be made until it is written.',
    'doc_templates.alert.kind_gone': 'Its module is off or no longer declares this kind: no new document of it is made.',
    'doc_templates.alert.awaiting': 'Waiting for signatures: {signed_count} of {signer_count} signed.',
    'doc_templates.alert.yours': 'Your signature is awaited.',
    'doc_templates.alert.superseded': 'A correction replaced this revision: its signatures no longer stand.',
    'doc_templates.alert.withdrawn': 'Withdrawn: {withdraw_reason}',
    'doc_templates.card.titles': 'Titles',
    'doc_templates.card.titles.empty': 'Not written yet.',
    'doc_templates.card.file': 'The file',
    'doc_templates.card.file.note': 'The PDF as it was made, kept in media. Nothing about it changes.',
    'doc_templates.card.empty': 'No document yet.',
    'doc_templates.tab.fields': 'Fields',
    'doc_templates.tab.signers': 'Signers',
    'doc_templates.tab.versions': 'Versions',
    'doc_templates.tab.data': 'Data',
    'doc_templates.tab.trail': 'Trail',
    'doc_templates.table.fields': 'What the text may print',
    'doc_templates.table.fields.note': 'A statutory field is stated in both texts, outside any condition: a text without it is not saved.',
    'doc_templates.table.versions.note': 'A version is never changed: each document names the version it was made from.',
    'doc_templates.table.signatures': 'Signatures',
    'doc_templates.table.signatures.note': 'Each signature is on the fingerprint above. A correction voids them all: its revision is signed afresh.',
    'doc_templates.table.data': 'The data it was made from',
    'doc_templates.table.data.note': 'Frozen when the document was made; a change is a new revision.',
    'doc_templates.table.trail.note': 'Append-only: nothing in it is ever changed or removed.',
    'doc_templates.col.name': 'Document',
    'doc_templates.col.title': 'Document',
    'doc_templates.col.state': 'State',
    'doc_templates.col.status': 'Status',
    'doc_templates.col.current_version': 'Version',
    'doc_templates.col.version': 'Version',
    'doc_templates.col.version_number': 'Version',
    'doc_templates.col.statutory_count': 'Statutory fields',
    'doc_templates.col.signer_count': 'Signers',
    'doc_templates.col.signed_count': 'Signed',
    'doc_templates.col.updated_at': 'Last saved',
    'doc_templates.col.saved_at': 'Saved',
    'doc_templates.col.made_at': 'Made',
    'doc_templates.col.kind': 'Kind',
    'doc_templates.col.kind_name': 'Kind',
    'doc_templates.col.module': 'Module',
    'doc_templates.col.id': 'Id',
    'doc_templates.col.kind_available': 'Kind available',
    'doc_templates.col.signing': 'Signing order',
    'doc_templates.col.title_ar': 'Title (Arabic)',
    'doc_templates.col.title_en': 'Title (English)',
    'doc_templates.col.body_ar': 'Text (Arabic)',
    'doc_templates.col.body_en': 'Text (English)',
    'doc_templates.col.label': 'Field',
    'doc_templates.col.placeholder': 'Write',
    'doc_templates.col.type': 'Type',
    'doc_templates.col.statutory': 'Statutory',
    'doc_templates.col.order': 'Order',
    'doc_templates.col.signer': 'Signer',
    'doc_templates.col.by': 'Who',
    'doc_templates.col.note': 'What changed',
    'doc_templates.col.source': 'From',
    'doc_templates.col.number': 'Number',
    'doc_templates.col.revision': 'Revision',
    'doc_templates.col.template_version': 'Text version',
    'doc_templates.col.language': 'Language',
    'doc_templates.col.subject_label': 'About',
    'doc_templates.col.sha256': 'Fingerprint (SHA-256)',
    'doc_templates.col.completed_at': 'Completed',
    'doc_templates.col.withdrawn_at': 'Withdrawn',
    'doc_templates.col.withdraw_reason': 'Reason',
    'doc_templates.col.can_sign': 'Can sign',
    'doc_templates.col.can_withdraw': 'Can withdraw',
    'doc_templates.col.slot_state': 'State',
    'doc_templates.col.signer_name': 'Signed by',
    'doc_templates.col.capacity': 'Capacity',
    'doc_templates.col.signed_at': 'Signed',
    'doc_templates.col.value': 'Value',
    'doc_templates.col.event': 'What',
    'doc_templates.col.at': 'When',
    'doc_templates.col.document_sha256': 'On fingerprint',
    'doc_templates.field.kind': 'Document kind',
    'doc_templates.field.kind.help': 'A kind with a starter text begins from it.',
    'doc_templates.field.title_ar': 'Title (Arabic)',
    'doc_templates.field.title_en': 'Title (English)',
    'doc_templates.field.body_ar': 'Text (Arabic)',
    'doc_templates.field.body_en': 'Text (English)',
    'doc_templates.field.body.help': '{{field}} prints a field; {{#if field}} … {{/if}} and {{#each list}} … {{/each}}; a line starting # is a heading, - an item.',
    'doc_templates.field.body_en.help': 'Every statutory field is stated in both texts, outside any condition.',
    'doc_templates.field.note': 'What changed',
    'doc_templates.field.page_size': 'Paper',
    'doc_templates.field.page_orientation': 'Orientation',
    'doc_templates.field.page_width_mm': 'Width (mm)',
    'doc_templates.field.page_height_mm': 'Height (mm)',
    'doc_templates.page.a4': 'A4',
    'doc_templates.page.a3': 'A3',
    'doc_templates.page.a5': 'A5',
    'doc_templates.page.letter': 'Letter',
    'doc_templates.page.custom': 'Custom size',
    'doc_templates.page.portrait': 'Portrait',
    'doc_templates.page.landscape': 'Landscape',
    'doc_templates.field.note.help': 'Kept with the version.',
    'doc_templates.field.capacity': 'Signing as',
    'doc_templates.field.capacity.help': 'Your capacity, as the document should record it: «HR manager», «the tenant».',
    'doc_templates.field.intent': 'I have read this document and sign it in that capacity.',
    'doc_templates.field.reason': 'Why it is withdrawn',
    'doc_templates.state.active': 'In use',
    'doc_templates.state.unwritten': 'Not written',
    'doc_templates.state.retired': 'Retired',
    'doc_templates.status.awaiting': 'Awaiting signatures',
    'doc_templates.status.completed': 'Complete',
    'doc_templates.status.superseded': 'Superseded',
    'doc_templates.status.withdrawn': 'Withdrawn',
    'doc_templates.slot_state.signed': 'Signed',
    'doc_templates.slot_state.open': 'Awaited',
    'doc_templates.slot_state.waiting': 'After an earlier signer',
    'doc_templates.slot_state.void': 'Void',
    'doc_templates.slot_state.unsigned': 'Not signed',
    'doc_templates.signing.sequential': 'In order',
    'doc_templates.signing.parallel': 'All at once',
    'doc_templates.signer_by.permission': 'Whoever holds the permission',
    'doc_templates.signer_by.party': 'The person the document names',
    'doc_templates.source.starter': 'Starter text',
    'doc_templates.source.edit': 'Written here',
    'doc_templates.language.ar': 'Arabic',
    'doc_templates.language.en': 'English',
    'doc_templates.type.text': 'Text',
    'doc_templates.type.number': 'Number',
    'doc_templates.type.money': 'Amount',
    'doc_templates.type.date': 'Date',
    'doc_templates.type.duration': 'Length of time',
    'doc_templates.type.boolean': 'Yes or no',
    'doc_templates.type.party': 'Person (for signing)',
    'doc_templates.type.list': 'List',
    'doc_templates.event.generated': 'Made',
    'doc_templates.event.signed': 'Signed',
    'doc_templates.event.completed': 'Completed',
    'doc_templates.event.voided': 'Signatures voided',
    'doc_templates.event.superseded': 'Superseded',
    'doc_templates.event.withdrawn': 'Withdrawn',
    'doc_templates.refusal.not_found': 'No such record among those you may see.',
    'doc_templates.refusal.stale': 'The template changed since it was read; reload and try again.',
    'doc_templates.refusal.page': 'Give the page as its size, orientation and, for a custom size, its width and height.',
    'doc_templates.refusal.page.size': 'The paper is A4, A3, A5, Letter or a custom size.',
    'doc_templates.refusal.page.orientation': 'The page lies portrait or landscape.',
    'doc_templates.refusal.page.side': 'A custom size needs a width and a height between {min} and {max} mm.',
    'doc_templates.refusal.page.named': 'A named paper has its own size; width and height are for a custom size.',
    'doc_templates.refusal.kind': 'Name the document kind as {module}.{key}.',
    'doc_templates.refusal.kind_unknown': 'This is not a document kind of a module this workspace has on.',
    'doc_templates.refusal.kind_forbidden': 'Your role does not allow making or correcting this kind of document.',
    'doc_templates.refusal.unwritten': 'The workspace has not written the text of this document yet.',
    'doc_templates.refusal.identity_forbidden': 'Identity would not answer for you.',
    'doc_templates.refusal.identity_unavailable': 'Identity could not be asked just now; try again.',
    'doc_templates.refusal.media_forbidden': 'The file store would not keep or give the PDF for you.',
    'doc_templates.refusal.media_unavailable': 'The file store could not be reached; try again.',
    'doc_templates.refusal.subject': 'The record is written {module}.{entity}.{id}.',
    'doc_templates.refusal.subject_required': 'A document of this kind names the record it is about.',
    'doc_templates.refusal.subject_entity': 'A document of this kind is about another kind of record.',
    'doc_templates.refusal.language': 'The language is Arabic or English.',
    'doc_templates.refusal.not_text': 'This must be text.',
    'doc_templates.refusal.too_long': 'This is too long.',
    'doc_templates.refusal.title_ar_required': 'Write the Arabic title.',
    'doc_templates.refusal.title_en_required': 'Write the English title.',
    'doc_templates.refusal.body_ar_required': 'Write the Arabic text.',
    'doc_templates.refusal.body_en_required': 'Write the English text.',
    'doc_templates.refusal.capacity_required': 'Say in what capacity you sign.',
    'doc_templates.refusal.reason_required': 'Say why the document is withdrawn.',
    'doc_templates.refusal.intent': 'Confirm that you have read the document and sign it.',
    'doc_templates.refusal.hash': 'The document fingerprint is 64 hexadecimal characters.',
    'doc_templates.refusal.hash_mismatch': 'The document you were shown is not this one: reload it before you sign.',
    'doc_templates.refusal.superseded': 'This document was corrected: sign its latest revision.',
    'doc_templates.refusal.not_awaiting': 'This document is not waiting for signatures.',
    'doc_templates.refusal.not_current': 'Only the current revision of a document is corrected or withdrawn.',
    'doc_templates.refusal.signed_already': 'You have signed this document already.',
    'doc_templates.refusal.slot_unknown': 'That is not a signer of this document.',
    'doc_templates.refusal.slot_signed': 'That slot is signed already; reload the document.',
    'doc_templates.refusal.not_signer': 'You are not one of the signers this document is waiting for.',
    'doc_templates.refusal.not_your_turn': 'An earlier signer signs first.',
    'doc_templates.refusal.signer_mismatch': 'Identity names somebody else: sign in again.',
    'doc_templates.refusal.adapter': 'The signature could not be completed.',
    'doc_templates.refusal.withdraw_forbidden': 'Your role does not allow withdrawing this document.',
    'doc_templates.refusal.template.text': 'A template is text.',
    'doc_templates.refusal.template.too_long': 'The text is too long.',
    'doc_templates.refusal.template.stray_braces': 'A {{ or }} opens or closes no placeholder.',
    'doc_templates.refusal.template.name': 'A placeholder is {{field}}: lower-case letters, digits and _.',
    'doc_templates.refusal.template.depth': 'Conditions and lists nest too deep.',
    'doc_templates.refusal.template.else': '{{else}} stands only inside an {{#if}}, once.',
    'doc_templates.refusal.template.close': 'This closes nothing that is open.',
    'doc_templates.refusal.template.unclosed': 'A condition or list is never closed.',
    'doc_templates.refusal.template.unknown_field': '{field} is not a field of this document.',
    'doc_templates.refusal.template.column_outside': '{field} is a list: read its columns inside {{#each}}.',
    'doc_templates.refusal.template.list_printed': '{field} is a list: print its rows with {{#each}}.',
    'doc_templates.refusal.template.party_printed': '{field} names who signs and is never printed.',
    'doc_templates.refusal.template.each_not_list': '{field} is not a list.',
    'doc_templates.refusal.template.statutory_missing': '{field} is statutory: state it in this text, outside any condition.',
    'doc_templates.refusal.template.title_line': 'A title is one line.',
    'doc_templates.refusal.template.title_blocks': 'A title holds no condition or list.',
    'doc_templates.refusal.data.object': 'The data is an object of the document\'s fields.',
    'doc_templates.refusal.data.unknown_field': '{field} is not a field of this document.',
    'doc_templates.refusal.data.required': '{field} is required.',
    'doc_templates.refusal.data.type': '{field} is not of its type.',
    'doc_templates.refusal.data.too_long': '{field} is too long.',
    'doc_templates.refusal.data.too_many': '{field} has too many rows.',
    'change.field.template.module': 'Module',
    'change.field.template.current_version': 'Version',
    'change.field.template.number': 'Version',
    'change.field.template.title_ar': 'Title (Arabic)',
    'change.field.template.title_en': 'Title (English)',
    'change.field.template.body_ar': 'Text (Arabic)',
    'change.field.template.body_en': 'Text (English)',
    'change.field.template.note': 'What changed',
    'change.field.template.source': 'From',
    'change.field.template.page': 'Page',
    'change.field.document.series_id': 'Series',
    'change.field.document.revision': 'Revision',
    'change.field.document.template_id': 'Template',
    'change.field.document.template_version': 'Text version',
    'change.field.document.subject_entity': 'Record type',
    'change.field.document.subject_id': 'Record',
    'change.field.document.subject_label': 'About',
    'change.field.document.language': 'Language',
    'change.field.document.title': 'Title',
    'change.field.document.input_snapshot': 'Data',
    'change.field.document.sha256': 'Fingerprint',
    'change.field.document.size_bytes': 'Size',
    'change.field.document.media_file_id': 'File',
    'change.field.document.superseded_by': 'Superseded by',
    'change.field.document.completed_at': 'Completed',
    'change.field.document.created_by_party': 'Made by (person)',
    'change.field.document.slot': 'Signer slot',
    'change.field.document.slot_order': 'Order',
    'change.field.document.signer_user': 'Signer',
    'change.field.document.signer_party': 'Signer (person)',
    'change.field.document.signer_name': 'Signer name',
    'change.field.document.capacity': 'Capacity',
    'change.field.document.intent': 'Stated intent',
    'change.field.document.document_sha256': 'Signed fingerprint',
    'change.field.document.method': 'Method',
    'change.field.document.adapter_ref': 'Provider reference',
    'change.field.document.signed_at': 'Signed',
};
export const DOC_TEMPLATES_AR = {
    'nav.module.doc_templates': 'قوالب المستندات',
    'nav.doc_templates.templates': 'قوالب المستندات',
    'screen.doc_templates.templates.title': 'قوالب المستندات',
    'screen.doc_templates.template.title': 'قالب مستند',
    'screen.doc_templates.document.title': 'مستند',
    'entity.doc_templates.template': 'قالب مستند',
    'entity.doc_templates.document': 'مستند',
    'entity.doc_templates.subject': 'المستندات',
    'doc_templates.templates.title': 'قوالب المستندات',
    'doc_templates.templates.lede': 'نصّ كل مستند تُصدره وحداتك، بالعربية والإنجليزية؛ كل حفظ إصدار جديد.',
    'doc_templates.templates.empty': 'لا قالب بعد: اختر نوع مستند لتكتب نصّه.',
    'doc_templates.template.title': 'قالب مستند',
    'doc_templates.template.monogram': 'ق',
    'doc_templates.document.title': 'مستند',
    'doc_templates.document.monogram': 'م',
    'doc_templates.subject_documents.title': 'المستندات',
    'doc_templates.stat.unwritten': 'لم يُكتب بعد',
    'doc_templates.action.create': 'قالب جديد',
    'doc_templates.action.edit': 'تعديل النص',
    'doc_templates.action.sign': 'وقّع',
    'doc_templates.action.download': 'تنزيل PDF',
    'doc_templates.action.withdraw': 'سحب',
    'doc_templates.alert.unwritten': 'لا نصّ بعد: لا يُصدَر مستند من هذا النوع حتى يُكتب.',
    'doc_templates.alert.kind_gone': 'وحدته موقوفة أو لم تعد تعلن هذا النوع: لا يُصدَر منه مستند جديد.',
    'doc_templates.alert.awaiting': 'بانتظار التواقيع: وُقّع {signed_count} من {signer_count}.',
    'doc_templates.alert.yours': 'توقيعك مطلوب.',
    'doc_templates.alert.superseded': 'استُبدلت هذه المراجعة بتصحيح: تواقيعها لم تعد قائمة.',
    'doc_templates.alert.withdrawn': 'مسحوب: {withdraw_reason}',
    'doc_templates.card.titles': 'العنوانان',
    'doc_templates.card.titles.empty': 'لم يُكتب بعد.',
    'doc_templates.card.file': 'الملف',
    'doc_templates.card.file.note': 'ملف PDF كما صُنع، محفوظ في الوسائط. لا يتغيّر منه شيء.',
    'doc_templates.card.empty': 'لا مستند بعد.',
    'doc_templates.tab.fields': 'الحقول',
    'doc_templates.tab.signers': 'الموقّعون',
    'doc_templates.tab.versions': 'الإصدارات',
    'doc_templates.tab.data': 'البيانات',
    'doc_templates.tab.trail': 'السجل',
    'doc_templates.table.fields': 'ما يطبعه النص',
    'doc_templates.table.fields.note': 'الحقل النظامي يُذكر في النصّين خارج أي شرط: النص الذي يخلو منه لا يُحفظ.',
    'doc_templates.table.versions.note': 'الإصدار لا يُعدَّل: كل مستند يذكر الإصدار الذي صُنع منه.',
    'doc_templates.table.signatures': 'التواقيع',
    'doc_templates.table.signatures.note': 'كل توقيع على البصمة أعلاه. التصحيح يُسقطها كلّها، وتوقَّع مراجعته من جديد.',
    'doc_templates.table.data': 'البيانات التي صُنع منها',
    'doc_templates.table.data.note': 'مجمّدة منذ صُنع المستند؛ أي تغيير مراجعة جديدة.',
    'doc_templates.table.trail.note': 'إلحاق فقط: لا يُعدَّل فيه شيء ولا يُحذف.',
    'doc_templates.col.name': 'المستند',
    'doc_templates.col.title': 'المستند',
    'doc_templates.col.state': 'الحالة',
    'doc_templates.col.status': 'الحالة',
    'doc_templates.col.current_version': 'الإصدار',
    'doc_templates.col.version': 'الإصدار',
    'doc_templates.col.version_number': 'الإصدار',
    'doc_templates.col.statutory_count': 'الحقول النظامية',
    'doc_templates.col.signer_count': 'الموقّعون',
    'doc_templates.col.signed_count': 'وُقّع',
    'doc_templates.col.updated_at': 'آخر حفظ',
    'doc_templates.col.saved_at': 'حُفظ',
    'doc_templates.col.made_at': 'صدر',
    'doc_templates.col.kind': 'النوع',
    'doc_templates.col.kind_name': 'النوع',
    'doc_templates.col.module': 'الوحدة',
    'doc_templates.col.id': 'المعرّف',
    'doc_templates.col.kind_available': 'النوع متاح',
    'doc_templates.col.signing': 'ترتيب التوقيع',
    'doc_templates.col.title_ar': 'العنوان بالعربية',
    'doc_templates.col.title_en': 'العنوان بالإنجليزية',
    'doc_templates.col.body_ar': 'النص العربي',
    'doc_templates.col.body_en': 'النص الإنجليزي',
    'doc_templates.col.label': 'الحقل',
    'doc_templates.col.placeholder': 'يُكتب',
    'doc_templates.col.type': 'النوع',
    'doc_templates.col.statutory': 'نظامي',
    'doc_templates.col.order': 'الترتيب',
    'doc_templates.col.signer': 'الموقّع',
    'doc_templates.col.by': 'من يوقّع',
    'doc_templates.col.note': 'ما تغيّر',
    'doc_templates.col.source': 'المصدر',
    'doc_templates.col.number': 'الرقم',
    'doc_templates.col.revision': 'المراجعة',
    'doc_templates.col.template_version': 'إصدار النص',
    'doc_templates.col.language': 'اللغة',
    'doc_templates.col.subject_label': 'يخصّ',
    'doc_templates.col.sha256': 'البصمة (SHA-256)',
    'doc_templates.col.completed_at': 'اكتمل',
    'doc_templates.col.withdrawn_at': 'سُحب',
    'doc_templates.col.withdraw_reason': 'السبب',
    'doc_templates.col.can_sign': 'يمكنه التوقيع',
    'doc_templates.col.can_withdraw': 'يمكنه السحب',
    'doc_templates.col.slot_state': 'الحالة',
    'doc_templates.col.signer_name': 'وقّعه',
    'doc_templates.col.capacity': 'الصفة',
    'doc_templates.col.signed_at': 'وقت التوقيع',
    'doc_templates.col.value': 'القيمة',
    'doc_templates.col.event': 'ما جرى',
    'doc_templates.col.at': 'متى',
    'doc_templates.col.document_sha256': 'على البصمة',
    'doc_templates.field.kind': 'نوع المستند',
    'doc_templates.field.kind.help': 'النوع الذي له نصّ مبدئي يبدأ منه.',
    'doc_templates.field.title_ar': 'العنوان بالعربية',
    'doc_templates.field.title_en': 'العنوان بالإنجليزية',
    'doc_templates.field.body_ar': 'النص العربي',
    'doc_templates.field.body_en': 'النص الإنجليزي',
    'doc_templates.field.body.help': '{{field}} يطبع حقلاً؛ {{#if field}} … {{/if}} شرط و{{#each list}} … {{/each}} تكرار؛ السطر الذي يبدأ بـ # عنوان، وبـ - بند.',
    'doc_templates.field.body_en.help': 'كل حقل نظامي يُذكر في النصّين، خارج أي شرط.',
    'doc_templates.field.note': 'ما تغيّر',
    'doc_templates.field.page_size': 'الورق',
    'doc_templates.field.page_orientation': 'الاتجاه',
    'doc_templates.field.page_width_mm': 'العرض (مم)',
    'doc_templates.field.page_height_mm': 'الارتفاع (مم)',
    'doc_templates.page.a4': 'A4',
    'doc_templates.page.a3': 'A3',
    'doc_templates.page.a5': 'A5',
    'doc_templates.page.letter': 'Letter',
    'doc_templates.page.custom': 'مقاس مخصّص',
    'doc_templates.page.portrait': 'طولي',
    'doc_templates.page.landscape': 'عرضي',
    'doc_templates.field.note.help': 'يُحفظ مع الإصدار.',
    'doc_templates.field.capacity': 'التوقيع بصفة',
    'doc_templates.field.capacity.help': 'صفتك كما يسجّلها المستند: «مدير الموارد البشرية»، «المستأجر».',
    'doc_templates.field.intent': 'اطّلعت على هذا المستند وأوقّعه بهذه الصفة.',
    'doc_templates.field.reason': 'سبب السحب',
    'doc_templates.state.active': 'مستخدم',
    'doc_templates.state.unwritten': 'لم يُكتب',
    'doc_templates.state.retired': 'موقوف',
    'doc_templates.status.awaiting': 'بانتظار التواقيع',
    'doc_templates.status.completed': 'مكتمل',
    'doc_templates.status.superseded': 'مُستبدَل',
    'doc_templates.status.withdrawn': 'مسحوب',
    'doc_templates.slot_state.signed': 'موقَّع',
    'doc_templates.slot_state.open': 'مطلوب الآن',
    'doc_templates.slot_state.waiting': 'بعد موقّع سابق',
    'doc_templates.slot_state.void': 'ساقط',
    'doc_templates.slot_state.unsigned': 'لم يوقَّع',
    'doc_templates.signing.sequential': 'بالترتيب',
    'doc_templates.signing.parallel': 'معاً',
    'doc_templates.signer_by.permission': 'من يملك الصلاحية',
    'doc_templates.signer_by.party': 'الشخص الذي يسمّيه المستند',
    'doc_templates.source.starter': 'النص المبدئي',
    'doc_templates.source.edit': 'كُتب هنا',
    'doc_templates.language.ar': 'العربية',
    'doc_templates.language.en': 'الإنجليزية',
    'doc_templates.type.text': 'نص',
    'doc_templates.type.number': 'رقم',
    'doc_templates.type.money': 'مبلغ',
    'doc_templates.type.date': 'تاريخ',
    'doc_templates.type.duration': 'مدّة',
    'doc_templates.type.boolean': 'نعم أو لا',
    'doc_templates.type.party': 'شخص (للتوقيع)',
    'doc_templates.type.list': 'قائمة',
    'doc_templates.event.generated': 'صدر',
    'doc_templates.event.signed': 'وُقّع',
    'doc_templates.event.completed': 'اكتمل',
    'doc_templates.event.voided': 'سقطت التواقيع',
    'doc_templates.event.superseded': 'استُبدل',
    'doc_templates.event.withdrawn': 'سُحب',
    'doc_templates.refusal.not_found': 'لا يوجد سجلّ كهذا فيما يحقّ لك رؤيته.',
    'doc_templates.refusal.stale': 'تغيّر القالب منذ قرأته؛ أعد التحميل وحاول مجدداً.',
    'doc_templates.refusal.page': 'حدّد الصفحة بمقاسها واتجاهها، وبعرضها وارتفاعها للمقاس المخصّص.',
    'doc_templates.refusal.page.size': 'الورق A4 أو A3 أو A5 أو Letter أو مقاس مخصّص.',
    'doc_templates.refusal.page.orientation': 'الصفحة طولية أو عرضية.',
    'doc_templates.refusal.page.side': 'المقاس المخصّص يحتاج عرضاً وارتفاعاً بين {min} و{max} مم.',
    'doc_templates.refusal.page.named': 'للورق المسمّى مقاسه؛ العرض والارتفاع للمقاس المخصّص فقط.',
    'doc_templates.refusal.kind': 'اذكر نوع المستند بصيغة {module}.{key}.',
    'doc_templates.refusal.kind_unknown': 'هذا ليس نوع مستند لوحدة مفعّلة في مساحة العمل.',
    'doc_templates.refusal.kind_forbidden': 'دورك لا يسمح بإصدار هذا النوع من المستندات أو تصحيحه.',
    'doc_templates.refusal.unwritten': 'لم تكتب مساحة العمل نصّ هذا المستند بعد.',
    'doc_templates.refusal.identity_forbidden': 'لم تُجب الهوية عنك.',
    'doc_templates.refusal.identity_unavailable': 'تعذّر سؤال الهوية الآن؛ حاول مجدداً.',
    'doc_templates.refusal.media_forbidden': 'رفض مخزن الملفات حفظ ملف PDF أو إعطاءه لك.',
    'doc_templates.refusal.media_unavailable': 'تعذّر الوصول إلى مخزن الملفات؛ حاول مجدداً.',
    'doc_templates.refusal.subject': 'السجلّ يُكتب بصيغة {module}.{entity}.{id}.',
    'doc_templates.refusal.subject_required': 'مستند هذا النوع يذكر السجلّ الذي يخصّه.',
    'doc_templates.refusal.subject_entity': 'مستند هذا النوع يخصّ نوعاً آخر من السجلّات.',
    'doc_templates.refusal.language': 'اللغة عربية أو إنجليزية.',
    'doc_templates.refusal.not_text': 'يجب أن يكون نصاً.',
    'doc_templates.refusal.too_long': 'هذا أطول من المسموح.',
    'doc_templates.refusal.title_ar_required': 'اكتب العنوان بالعربية.',
    'doc_templates.refusal.title_en_required': 'اكتب العنوان بالإنجليزية.',
    'doc_templates.refusal.body_ar_required': 'اكتب النص العربي.',
    'doc_templates.refusal.body_en_required': 'اكتب النص الإنجليزي.',
    'doc_templates.refusal.capacity_required': 'اذكر الصفة التي توقّع بها.',
    'doc_templates.refusal.reason_required': 'اذكر سبب سحب المستند.',
    'doc_templates.refusal.intent': 'أكّد أنك اطّلعت على المستند وأنك توقّعه.',
    'doc_templates.refusal.hash': 'بصمة المستند 64 حرفاً ست عشرياً.',
    'doc_templates.refusal.hash_mismatch': 'المستند الذي عُرض عليك ليس هذا: أعد تحميله قبل التوقيع.',
    'doc_templates.refusal.superseded': 'صُحّح هذا المستند: وقّع مراجعته الأخيرة.',
    'doc_templates.refusal.not_awaiting': 'هذا المستند لا ينتظر تواقيع.',
    'doc_templates.refusal.not_current': 'لا يُصحَّح ولا يُسحب إلا آخر مراجعة من المستند.',
    'doc_templates.refusal.signed_already': 'وقّعت هذا المستند من قبل.',
    'doc_templates.refusal.slot_unknown': 'هذا ليس من موقّعي هذا المستند.',
    'doc_templates.refusal.slot_signed': 'هذه الخانة موقَّعة؛ أعد تحميل المستند.',
    'doc_templates.refusal.not_signer': 'لست من الموقّعين الذين ينتظرهم هذا المستند.',
    'doc_templates.refusal.not_your_turn': 'يوقّع موقّع سابق أولاً.',
    'doc_templates.refusal.signer_mismatch': 'الهوية تسمّي شخصاً آخر: سجّل الدخول مجدداً.',
    'doc_templates.refusal.adapter': 'تعذّر إتمام التوقيع.',
    'doc_templates.refusal.withdraw_forbidden': 'دورك لا يسمح بسحب هذا المستند.',
    'doc_templates.refusal.template.text': 'القالب نص.',
    'doc_templates.refusal.template.too_long': 'النص أطول من المسموح.',
    'doc_templates.refusal.template.stray_braces': 'علامة {{ أو }} لا تفتح حقلاً ولا تغلقه.',
    'doc_templates.refusal.template.name': 'الحقل يُكتب {{field}}: أحرف لاتينية صغيرة وأرقام و_.',
    'doc_templates.refusal.template.depth': 'الشروط والقوائم متداخلة أكثر من المسموح.',
    'doc_templates.refusal.template.else': '{{else}} يأتي داخل {{#if}} فقط، مرة واحدة.',
    'doc_templates.refusal.template.close': 'هذا لا يغلق شيئاً مفتوحاً.',
    'doc_templates.refusal.template.unclosed': 'شرط أو قائمة لم تُغلق.',
    'doc_templates.refusal.template.unknown_field': '{field} ليس حقلاً في هذا المستند.',
    'doc_templates.refusal.template.column_outside': '{field} قائمة: تُقرأ أعمدتها داخل {{#each}}.',
    'doc_templates.refusal.template.list_printed': '{field} قائمة: تُطبع صفوفها بـ {{#each}}.',
    'doc_templates.refusal.template.party_printed': '{field} يحدّد الموقّع ولا يُطبع.',
    'doc_templates.refusal.template.each_not_list': '{field} ليس قائمة.',
    'doc_templates.refusal.template.statutory_missing': '{field} حقل نظامي: اذكره في هذا النص خارج أي شرط.',
    'doc_templates.refusal.template.title_line': 'العنوان سطر واحد.',
    'doc_templates.refusal.template.title_blocks': 'العنوان لا يحوي شرطاً ولا قائمة.',
    'doc_templates.refusal.data.object': 'البيانات كائن من حقول المستند.',
    'doc_templates.refusal.data.unknown_field': '{field} ليس حقلاً في هذا المستند.',
    'doc_templates.refusal.data.required': '{field} مطلوب.',
    'doc_templates.refusal.data.type': '{field} ليس من نوعه.',
    'doc_templates.refusal.data.too_long': '{field} أطول من المسموح.',
    'doc_templates.refusal.data.too_many': '{field} فيه صفوف أكثر من المسموح.',
    'change.field.template.module': 'الوحدة',
    'change.field.template.current_version': 'الإصدار',
    'change.field.template.number': 'الإصدار',
    'change.field.template.title_ar': 'العنوان بالعربية',
    'change.field.template.title_en': 'العنوان بالإنجليزية',
    'change.field.template.body_ar': 'النص العربي',
    'change.field.template.body_en': 'النص الإنجليزي',
    'change.field.template.note': 'ما تغيّر',
    'change.field.template.source': 'المصدر',
    'change.field.template.page': 'الصفحة',
    'change.field.document.series_id': 'السلسلة',
    'change.field.document.revision': 'المراجعة',
    'change.field.document.template_id': 'القالب',
    'change.field.document.template_version': 'إصدار النص',
    'change.field.document.subject_entity': 'نوع السجلّ',
    'change.field.document.subject_id': 'السجلّ',
    'change.field.document.subject_label': 'يخصّ',
    'change.field.document.language': 'اللغة',
    'change.field.document.title': 'العنوان',
    'change.field.document.input_snapshot': 'البيانات',
    'change.field.document.sha256': 'البصمة',
    'change.field.document.size_bytes': 'الحجم',
    'change.field.document.media_file_id': 'الملف',
    'change.field.document.superseded_by': 'استُبدل بـ',
    'change.field.document.completed_at': 'اكتمل',
    'change.field.document.created_by_party': 'أصدره (الشخص)',
    'change.field.document.slot': 'خانة التوقيع',
    'change.field.document.slot_order': 'الترتيب',
    'change.field.document.signer_user': 'الموقّع',
    'change.field.document.signer_party': 'الموقّع (الشخص)',
    'change.field.document.signer_name': 'اسم الموقّع',
    'change.field.document.capacity': 'الصفة',
    'change.field.document.intent': 'النيّة المعلنة',
    'change.field.document.document_sha256': 'البصمة الموقَّعة',
    'change.field.document.method': 'الطريقة',
    'change.field.document.adapter_ref': 'مرجع المزوّد',
    'change.field.document.signed_at': 'وقت التوقيع',
};
//# sourceMappingURL=i18n-doc-templates.js.map